import styled from 'styled-components';
import { media, Column } from '@simplywallst/ui-core';

export const SplitColumn = styled(Column)`
  padding-bottom: ${({ theme }) => theme.x3spacePx}px;
  margin-top: ${({ theme }) => theme.x4spacePx}px;
  &:first-child {
    padding-right: ${({ theme }) => theme.x2spacePx}px;
    ${media.smDown`
      padding-right: 0;
    `}
  }
  &:last-child {
    padding-left: ${({ theme }) => theme.x2spacePx}px;
    ${media.smDown`
      padding-left: 0;
      margin-top: 0;
    `}
  }

  @media print {
    break-inside: avoid;
  }
`;

export const StatementWrapper = styled('section')`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
`;
